import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface UserState {
  user: any;
}

const initialState: UserState = {
  user: null,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setLoggedUser: (state, action: PayloadAction<any>) => {
      state.user = action.payload;
    },
    removeLoggedUser: (state) => {
      state.user = { user: null };
    },
  },
});

// Action creators are generated for each case reducer function
export const { setLoggedUser, removeLoggedUser } = userSlice.actions;

export default userSlice.reducer;
